import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';
import 'Lib/jquery.viewport';

import OneVideo from 'Modules/module-oneVideo';

"use strict";

var ViewCollection = Backbone.View.extend({

    initialize: function (opts) {
        console.log('init collection');
        var self = this;
        self.$pager = self.$el.find('.collection-pagination');
        self.$productGrid = self.$el.find('.collection-products');
        self.$highlightMenuSlider = self.$el.find('.collection-highlight-menu > .media-slider');
        self.$products = self.$productGrid.find('.item');
        self.$hotLinks = self.$el.find('.hot-links');

        // self.swatches();
        // self.addAll();
        if (!self.$el.hasClass('ss-enabled')) {
            self.infinityScroll();
        }
        // self.quickShopModal();
        self.promoVideo();
        // setTimeout(function(){
            // self.quickbuy();
        // }, 1000);

        if(self.$hotLinks.length > 0){
            self.hotLinkScroll();
        }

        if(self.$highlightMenuSlider.length > 0){
            self.initHighlightMenuSlider();
        }
    },
    
    events: {
        
    },
    
    // swatches: function(){
    //     var self = this;
    //     self.swatches = OneSwatches.init({ el: self.$productGrid, preSelect: false });
    // },

    initHighlightMenuSlider: function(){
        var self = this;

        self.$highlightMenuSlider.slick({
            infinite: false,
            arrows: true,
            speed: 600,
            dots: false,
            slidesToShow: 7,
            slidesToScroll: 1
        });
    },
    
    addAll: function() {
        // Add All requires Quickbuy
        var self = this;
        var addAllToBag = function(e){
            e.preventDefault();
            // Add CTA status change here..
            
            // Collecting data
            var productIds = [];
            _.each(self.$products, function(product){
                var $productSelected = $(product).find('select.product-single__variants');
                if ($productSelected.length) {
                    productIds.push($productSelected.val());
                }
            });
            
            // Add Multiple Products
            var data = {
                id : productIds,
                quantity : 1
            }, callback = function(line_item){
                // Success callback, cart loaded, please add CTA status change here..
                console.log(line_item);
                ajaxCart.load();
                $('header .block-minicart').trigger('click');
            }, errorCallback = function (XMLHttpRequest, textStatus) {
                // Error callback, please add extra error handling here
                var data = eval('(' + XMLHttpRequest.responseText + ')');
                console.log(data);
            };
            ShopifyAPI.addMultipleItems(data, callback, errorCallback);
        }
        
        var events = {
            'click .add-all-to-bag' : addAllToBag
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    infinityScroll: function () {
        var self = this;
        var events = {
            'click .item a' : function(e){
                var $curr = $(e.currentTarget);
                var $item = $curr.parents('.item');
                var pageIndex = $item.data('page');
                e.preventDefault();
                if (pageIndex) {
                    var currentUrl = ORW.utilities.getUrlParam(window.location.href,'page', pageIndex);
                    window.history.pushState(null, null, currentUrl);
                }
                window.location.href = $curr.prop('href');
            }
        };
        var loadMore = function(prev){ // Passing param to determin whether loading next page or prev
            var addPage = function(d){
                var $content = $(d).find('.product-collection');
                var $pager = $content.find('.collection-pagination');
                var $newItems = $content.find('.collection-products .item');
                var loadingPageNum = ORW.utilities.getUrlParam(self.url,'page');
                var afterAppend = function (index, item) {
                    
                    $(item).data('page',loadingPageNum);
                    
                    if (index == $newItems.length-1) {
                        // Perform re-init of product grid if needed
                        ORW.rebuildListing();
                        
                        // Need to re-init ajax cart
                        $('.add-to-cart-form').off('submit');
                        ajaxCart.init({
                            formSelector: '.add-to-cart-form',
                            addToCartSelector: '.add-to-cart-btn',
                            cartContainer: '#CartContainer',
                            cartCountSelector: '.minicart-count',
                            cartCostSelector: '#CartCost',
                            moneyFormat: theme.moneyFormat
                        });
                        
                        ORW.isLoading = false;
                        
                        if (prev) {
                            loadMore(true); // Recursive!!
                            $('html, body').animate({
                                scrollTop: self.$productGrid.prop("scrollHeight")
                            }, 0);
                        } else {
                            return false;
                        }
                    }
                }
                
                ORW.pagerStack.push(self.url);

                if (!ORW.isFinished) {
                    self.$pager = $pager;
                    $newItems.prependTo(self.$productGrid).each(afterAppend);
                } else {
                    self.$pager.replaceWith($pager);
                    self.$pager = $pager;
                    $newItems.appendTo(self.$productGrid).each(afterAppend);
                    window.history.pushState(null, null, self.url);
                }
                
            }
            
            // Start of Load More
            if (!ORW.isLoading) {
                var status = prev ? 'prev' : 'next';
                if (ORW.isFinished) {
                    // Load next page
                    self.url = self.$pager.find('.next a').length ? self.$pager.find('.next a').attr('href') : '';
                } else {
                    // Load prev page
                    self.url = self.$pager.find('.prev a').length ? self.$pager.find('.prev a').attr('href') : '';
                }

                if ($.inArray(self.url, ORW.pagerStack) == -1 && self.url) {
                    console.log('load ' + status);
                    ORW.isLoading = true;
                    $.get(self.url).done(addPage);
                } else {
                    if (prev) {
                        ORW.isFinished = true;
                        console.log('load prev finished');
                    } else {
                        $('#loadmore').addClass('disabled');
                        return false;
                    }
                }
            }
        }
        
        // Load Prev Page Trigger
        loadMore(true);
        
        // Load Next Page Triggers
        if ($('#loadmore:in-viewport').length) {
            loadMore();
        }
        $(window).on('scroll.listview', function () {
            if ($('#loadmore:in-viewport').length) {
                loadMore();
            }
        });
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    promoVideo: function () {
        var $videoBoxes = this.$el.find('.video-box');
        console.log('VIDEO BOX ', $videoBoxes);
        OneVideo.init({
            el: $videoBoxes
        });
    },

    hotLinkScroll: function() {
        var self = this;
        //find the li with class hot-link-active
        let hotLinkUl = self.$hotLinks[0]?.childNodes[1];
        let allTheLis = Array.from(hotLinkUl.children);
        let activeLink;
        let screenWidth = window.innerWidth;
        if(allTheLis.length > 0){
            for (let i = 0; i < allTheLis.length; i++) {
                let classes = Array.from(allTheLis[i].classList);
                if(classes.includes("hot-link-active")) {
                    activeLink = allTheLis[i];
                    let offset = activeLink.offsetLeft;
                    if(offset > screenWidth) {
                        hotLinkUl.scrollLeft += (offset);
                    }
                }
            }
        }
    },
    
    isMobile: function () {
        var self = this;
        var w = $(window).width();
        if (w <= ORW.responsiveSizes.large) {
            return true;
        }
        return false;
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
        // self.swatches.destroy();
        $(window).off('scroll.listview');
    }

});

export default ViewCollection;
